import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=2306f14c&scoped=true&"
import script from "./Logs.vue?vue&type=script&lang=js&"
export * from "./Logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2306f14c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2306f14c')) {
      api.createRecord('2306f14c', component.options)
    } else {
      api.reload('2306f14c', component.options)
    }
    module.hot.accept("./Logs.vue?vue&type=template&id=2306f14c&scoped=true&", function () {
      api.rerender('2306f14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Operator/Components/Logs.vue"
export default component.exports